import React from 'react'
import { Link } from 'react-router-dom'
import {
  generateCreateUrlFromCategory,
  generateCreateUrl,
  getOnboardingPathSlug
} from '#src/services/path'
import { DepartmentConsumer } from '#src/context/department'
import styles from './styles.css'

const ChatWithExpert: React.FC = () => {
  return (
    <DepartmentConsumer>
      {({ department }) => (
        <div className={styles.module} data-testid="guest-cart-expert-callout">
          <div className={styles.copy}>
            👋 Hey, we noticed you haven't chatted with{' '}
            {department ? `a ${department.displayName} expert` : 'an expert'} yet! We highly
            recommend it - it's free.
          </div>
          <Link
            to={
              department
                ? generateCreateUrlFromCategory({
                    maybeCategorySlug: department.topLevelCategory.slug,
                    sourceKey: 'guest-cart-chat-with-expert',
                    pathIntent: 'request'
                  })
                : generateCreateUrl({
                    sourceKey: 'guest-cart-chat-with-expert',
                    pathIntent: 'request',
                    maybePathSlug: getOnboardingPathSlug()
                  })
            }
            className={styles.link}
          >
            Chat with an expert
          </Link>
        </div>
      )}
    </DepartmentConsumer>
  )
}

export default ChatWithExpert
